module.exports = __webpack_public_path__ + "fonts/Arzypto-Dashboard.39e4428.ttf";